import { render, staticRenderFns } from "./TranslationsTablePage.vue?vue&type=template&id=c6793ce4&scoped=true"
import script from "./TranslationsTablePage.vue?vue&type=script&lang=js"
export * from "./TranslationsTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6793ce4",
  null
  
)

export default component.exports